exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".not-found-container {\n  height: 100%;\n  display: grid;\n  align-content: center;\n  margin: auto;\n  justify-content: center;\n  font-size: 30px;\n  text-align: center; }\n  .not-found-container img {\n    width: 100%;\n    margin: 12px 0; }\n  .not-found-container a {\n    margin: 24px 0;\n    color: blue !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Shared/NotFound/NotFound.scss
// module id = 311
// module chunks = 0